const _has = Object.prototype.hasOwnProperty;

const Listener = function() {
    this._next = null;
    this._prev = null;
    this._func = null;
    this._ctx = null;
};

Listener.prototype = {
    destroy: function() {
        if (this._func === null) {
            return;
        }

        this._func = null;
        this._ctx = null;

        const prev = this._prev;
        const next = this._next;

        if (prev !== null) {
            prev._next = next;
            this._prev = null;
        }

        if (next !== null) {
            next._prev = prev;

            // Leave this._next untouched so it can still be
            // followed in case e.g. destroy() is called inside
            // _func.
        }
    }
};

const ListenerGroup = function(listeners) {
    this._listeners = listeners;
};

ListenerGroup.prototype = {
    destroy: function() {
        const listeners = this._listeners;
        if (listeners === null) {
            return;
        }

        this._listeners = null;

        while (listeners.length > 0) {
            const listener = listeners.pop();
            listener.destroy();
        }
    }
};

const listen = function(types, type, func, ctx) {
    const newHead = new Listener();

    let oldHead = types[type];
    if (!oldHead) {
        oldHead = new Listener();
    }

    oldHead._func = func;
    oldHead._ctx = ctx;
    oldHead._prev = newHead;

    newHead._next = oldHead;
    types[type] = newHead;

    return oldHead;
};

const zeroArgs = [];

const EventSource = function() {
};

EventSource.prototype = {
    _eventSourceListeners: null,

    trigger: function(type) {
        const types = this._eventSourceListeners;
        let head = null;

        if (types !== null && (head = types[type]) !== void 0 && (head = head._next) !== null) {
            const length = arguments.length - 1;
            const args = length === 0 ? zeroArgs : new Array(length);
            for (let i = 0; i < length; i++) {
                args[i] = arguments[i + 1];
            }

            while (head !== null) {
                const func = head._func;
                if (func !== null) {
                    func.apply(head._ctx, args);
                }
                head = head._next;
            }
        }
    },

    listen: function(type, func, ctx) {
        let types = this._eventSourceListeners;
        if (types === null) {
            types = Object.create(null);
            this._eventSourceListeners = types;
        }

        if (typeof type === "string") {
            return listen(types, type, func, ctx);
        }

        const listeners = [];
        for (const key in type) {
            if (_has.call(type, key)) {
                listeners.push(listen(types, key, type[key], func));
            }
        }
        return new ListenerGroup(listeners);
    }
};

export default EventSource;



// WEBPACK FOOTER //
// ./src/abusesa-js/EventSource.js